export default __webpack_public_path__ + "dcc15b831ae60d933ee5a2ea95d0ebc5.png";